export default __webpack_public_path__ + "static/media/storm.af7a66b0.svg";